export const mockImgAvatar = (index, genre?) => `../assets/avatar/${genre}/avatar-${index}.png`

export const mockImgAvatarSkin = (index) => `/assets/avatar/skins/avataaars_${(index)}.svg`
